import { FC, useState } from 'react';
import styled from 'styled-components';

import FiltersDropdown from '@/components/FilterDropdown';
import FilterButton from '@/components/FilterDropdown/FilterButton';
import FilterRadioButton from '@/components/FilterDropdown/FilterRadioButton';
import {
  FilterGroupBody,
  FilterGroupHeader,
  FilterGroupTitle,
  FilterWrap,
} from '@/components/FilterDropdown/Parts';
import Tooltiped from '@/components/Tooltiped';
import { EditorialFacebookPostType } from '@/utils/enums';

const StyledFilterButton = styled(FilterButton)`
  margin: 0 !important;
  border-color: ${({ theme }) => theme.colors.grayscale};

  &:hover {
    border-color: ${({ theme }) => theme.colors.lightGray};
  }
`;

interface Props {
  setContentType: React.Dispatch<
    React.SetStateAction<EditorialFacebookPostType | null>
  >;
  contentType: EditorialFacebookPostType | null;
}

const ContentTypeTableFilter: FC<Props> = ({ contentType, setContentType }) => {
  const [show, setShow] = useState(false);

  return (
    <FilterWrap>
      <Tooltiped title="Content Type">
        <StyledFilterButton
          isActive={show}
          text=""
          onClick={(e) => {
            e?.stopPropagation();
            setShow((prev) => !prev);
          }}
          filterApplied={!!contentType}
        />
      </Tooltiped>
      {show && (
        <FiltersDropdown onClose={() => setShow(false)}>
          <FilterGroupHeader>
            <FilterGroupTitle>Content Type</FilterGroupTitle>
          </FilterGroupHeader>
          <FilterGroupBody>
            {/* <FilterMultiselect<string>
                label="By Type:"
                values={selectedTypes}
                setValues={setSelectTypes}
                options={typeOptions}
              /> */}
            <FilterRadioButton
              id={`typeRadio-all`}
              value={''}
              checked={!contentType}
              setValue={() => setContentType(null)}
            >
              All
            </FilterRadioButton>
            <FilterRadioButton
              id={`typeRadio-link`}
              value={EditorialFacebookPostType.LINK.toString()}
              checked={contentType === EditorialFacebookPostType.LINK}
              setValue={() => setContentType(EditorialFacebookPostType.LINK)}
            >
              Link
            </FilterRadioButton>
            <FilterRadioButton
              id={`typeRadio-share`}
              value={EditorialFacebookPostType.SHARE.toString()}
              checked={contentType === EditorialFacebookPostType.SHARE}
              setValue={() => setContentType(EditorialFacebookPostType.SHARE)}
            >
              Share
            </FilterRadioButton>
            <FilterRadioButton
              id={`typeRadio-image`}
              value={EditorialFacebookPostType.IMAGE.toString()}
              checked={contentType === EditorialFacebookPostType.IMAGE}
              setValue={() => setContentType(EditorialFacebookPostType.IMAGE)}
            >
              Image
            </FilterRadioButton>
            <FilterRadioButton
              id={`typeRadio-reel`}
              value={EditorialFacebookPostType.REEL.toString()}
              checked={contentType === EditorialFacebookPostType.REEL}
              setValue={() => setContentType(EditorialFacebookPostType.REEL)}
            >
              Reel
            </FilterRadioButton>
            <FilterRadioButton
              id={`typeRadio-video`}
              value={EditorialFacebookPostType.VIDEO.toString()}
              checked={contentType === EditorialFacebookPostType.VIDEO}
              setValue={() => setContentType(EditorialFacebookPostType.VIDEO)}
            >
              Video
            </FilterRadioButton>
            <FilterRadioButton
              id={`typeRadio-story`}
              value={EditorialFacebookPostType.STORY.toString()}
              checked={contentType === EditorialFacebookPostType.STORY}
              setValue={() => setContentType(EditorialFacebookPostType.STORY)}
            >
              Story
            </FilterRadioButton>
            <FilterRadioButton
              id={`typeRadio-text`}
              value={EditorialFacebookPostType.TEXT.toString()}
              checked={contentType === EditorialFacebookPostType.TEXT}
              setValue={() => setContentType(EditorialFacebookPostType.TEXT)}
            >
              Text
            </FilterRadioButton>
            <FilterRadioButton
              id={`typeRadio-image-album`}
              value={EditorialFacebookPostType.IMAGE_ALBUM.toString()}
              checked={contentType === EditorialFacebookPostType.IMAGE_ALBUM}
              setValue={() =>
                setContentType(EditorialFacebookPostType.IMAGE_ALBUM)
              }
            >
              Image Album
            </FilterRadioButton>
          </FilterGroupBody>
        </FiltersDropdown>
      )}
    </FilterWrap>
  );
};

export default ContentTypeTableFilter;
